/** declare only http service related requests */

import { HttpTokens, GetTrainingChart, QueryTrainingChart } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
import { AxiosResponse } from 'axios';
import { paramsQueryString } from '@/utils/index';

/**
 * @description Get training charts overview on dashboard page
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const TrainingChartsGet = (
  prefix: string = 'trainings/charts',
  query: QueryTrainingChart,
  tokens: HttpTokens,
  hardRejection = true
): Promise<GetTrainingChart> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  // token not yet set on backend
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };
  const queryUri = paramsQueryString(`${prefix}`, query || {});

  return instance.client
    .get(queryUri, config)
    .then((d: AxiosResponse<GetTrainingChart>) => {
      // return Promise.reject(new Error('ups')) as any;
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetTrainingChart>;
};
